export const SET_CHANNEL_HISTORY = "SET_CHANNEL_HISTORY";
export const SET_CHANNEL = "SET_CHANNEL";
export const RESET_MESSAGE_STATUS = "RESET_MESSAGE_STATUS";
export const RESET_CHAT = "RESET_CHAT";
export const SET_CONNECTION = "SET_CONNECTION";
export const CHAT_OPEN = "CHAT_OPEN";
